// extracted by mini-css-extract-plugin
export default {"container":"style_container__y4jmD","section":"style_section__GVydU","ssection":"style_ssection__YwuQh"};